import { render } from "./listFile.vue?vue&type=template&id=29ab58c4&scoped=true"
import script from "./listFile.vue?vue&type=script&lang=js"
export * from "./listFile.vue?vue&type=script&lang=js"

import "./listFile.vue?vue&type=style&index=0&id=29ab58c4&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ab58c4"]])

export default __exports__